import { render, staticRenderFns } from "./icon-ask-mark.vue?vue&type=template&id=1cf8382c"
import script from "./icon-ask-mark.vue?vue&type=script&lang=ts"
export * from "./icon-ask-mark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports